import React, { useState } from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Create_Api } from "../../ApiUrls";

function Login() {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('Hostess');
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const [IsUploading, setIsUploading] = useState(false);
  const [Email, setEmail] = useState('');
  const [Password, setPassword] = useState('');

  const HostessLogin = async () => {
    if (!Email || !Password) {
      toast.error('Email and Password are required!');
      return;
    }
    try {
      let data = {
        Email,
        Password
      }
      setIsUploading(true)
      const response = await Create_Api(`api/hostess/Login`, data)
      console.log('User Login Successfull:', response);
      localStorage.setItem('user', JSON.stringify(response?.data));
      localStorage.setItem('userType', JSON.stringify('Hostess'));
      localStorage.setItem('userid', response?.data?.Hostess?._id);
      localStorage.setItem('userToken', response?.data?.token);
      toast.success(response?.message);
      setEmail('')
      setPassword('')
      if (!response?.data?.Hostess?.AboutMe || !response?.data?.Hostess?.Country || !response?.data?.Hostess?.City) {
        navigate('/addabout')
      }
      else {
        navigate('/profile')
      }
      setIsUploading(false)
    } catch (error) {
      setIsUploading(false)
      toast.error(error?.response?.data?.message);
      console.log(error)
    }
  }
  const UserLogin = async () => {
    if (!Email || !Password) {
      toast.error('Email and Password are required!');
      return;
    }
    try {
      let data = {
        Email,
        Password
      }
      setIsUploading(true)
      const response = await Create_Api(`api/user/Login`, data, { withCredentials: true })
      console.log('User Login Successfull:', response);
      localStorage.setItem('user', JSON.stringify(response?.data));
      localStorage.setItem('userType', JSON.stringify('User'));
      localStorage.setItem('userid', response?.data?.User?._id);
      localStorage.setItem('userToken', response?.data?.token);
      toast.success(response?.message);
      setEmail('')
      setPassword('')
      navigate('/allmodal')
      setIsUploading(false)
    } catch (error) {
      setIsUploading(false)
      toast.error(error?.response?.data?.message);
      console.log(error)
    }
  }



  return (
    <>
      <Navbar />
      <div className="login-div">
        <div className="login-form">
          {/* <div className="login-form-left">
          </div> */}
          <div className="login-form-right">
            <div className="noacc">

              <p>Welcome to <span>Hostess</span></p>
              {/* <Link to='/signup'>

                <h6>No Account ?<br />
                  Sign up</h6>
              </Link> */}
            </div>
            <br />
            <h3>Log in</h3>
            <br />
            <div className="tab-container">
              <div className="tabs">
                <button
                  className={activeTab === "Hostess" ? "tab-btn active" : "tab-btn"}
                  onClick={() => handleTabChange('Hostess')}>
                  I am a Hostess/Model
                </button>
                <button
                  className={activeTab === "User" ? "tab-btn active" : "tab-btn"}
                  onClick={() => handleTabChange('User')}>
                  I am Looking for a Hostess/Model
                </button>

              </div>
            </div>

            <br />
            {activeTab === "Hostess" && (
              <>
                <label>Enter your email address</label>
                <input
                  type="email"
                  placeholder="email address"
                  value={Email}
                  onChange={(e) => { setEmail(e.target.value) }}
                />
                <br />
                <label>Enter your Password</label>
                <input
                  type="password"
                  placeholder="Password"
                  value={Password}
                  onChange={(e) => { setPassword(e.target.value) }}
                />
                <div className="forget">
                  <br />
                  <div style={{ cursor: 'pointer' }} onClick={() => { navigate('/HostessForgotPassword') }}>
                    <h6>Forgot Password</h6>
                  </div>
                  <br />
                  <br />
                  <br />
                  <button onClick={HostessLogin}>
                    {IsUploading ? 'Wait...' : 'Log in'}
                  </button>
                </div>
              </>
            )}
            {activeTab === "User" && (
              <>
                <label>Enter your  email address</label>
                <input
                  placeholder=" email address"
                  value={Email}
                  onChange={(e) => { setEmail(e.target.value) }}
                />
                <br />
                <label>Enter your Password</label>
                <input
                  type="password"
                  placeholder="Password"
                  value={Password}
                  onChange={(e) => { setPassword(e.target.value) }}
                />
                <div className="forget">
                  <br />
                  <div style={{ cursor: 'pointer' }} onClick={() => { navigate('/ForgotPassword') }}>
                    <h6>Forgot Password</h6>
                  </div>
                  <br />
                  <br />
                  <br />

                  <button onClick={UserLogin}>{IsUploading ? 'Wait...' : 'Log in'}</button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Login;
